export default __webpack_public_path__ + "static/media/wag-tag.85383862.svg";